/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Row, Col } from 'antd'
import {
  DollarCircleOutlined,
  AreaChartOutlined,
  StockOutlined,
  HourglassOutlined,
  ClockCircleOutlined,
  DingdingOutlined
} from '@ant-design/icons'
import NumberFormat from 'react-number-format'
import useUserDragonDetails from '../../hooks/useUserDragonDetails'
import useUserEarningSorFar from '../../hooks/useUserEarningSorFar'
import useEstimatedDailyYield from '../../hooks/useEstimatedDailyYield'
import { useWeb3React } from '@web3-react/core'
import CartFullCountDownTimer from './DragonStatistic/CartFullCountDownTimer'
import NextBonusTimeTimer from './DragonStatistic/NextBonusTimeTimer'
import SellDragonsButton from './DragonStatistic/SellDragonsButton'
import BreedMoreButton from './DragonStatistic/BreedMoreButton'
export default function DragonFarmStatWidget(props) {

  const { accountAddress } = props

  const { userDragonDetails } = useUserDragonDetails({ accountAddress })
  const { userAvailableEarning, animatedClass } = useUserEarningSorFar({ accountAddress })
  const { estimatedDailyYield } = useEstimatedDailyYield({ accountAddress })
  const { account } = useWeb3React()

  return (
    <div className='dragon-farm-statistic-dashboard-container'>
      <div className='dragon-farm-statistic-title'>
        Your Dragon Farm Statistics
      </div>

      <Row className='dragon-farm-statistic-container'>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className='stat-details-topic'>
            <DingdingOutlined style={{ marginRight: '5px', marginTop: '4px' }} /> Your dragon farm
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className='stat-details-value'>
            <span className="dragon-amount-stat">
              {userDragonDetails ? userDragonDetails.miners : 0}
            </span><span className="dragon-amount-dollar-value">dragons</span>
          </div>
        </Col>
      </Row>

      <Row className='dragon-farm-statistic-container'>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className='stat-details-topic'>
            <DollarCircleOutlined style={{ marginRight: '5px', marginTop: '4px' }} /> Your earning so far
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className={'stat-details-value ' + animatedClass}>
            <span className="dragon-amount-stat">
              <NumberFormat
                value={userAvailableEarning ? userAvailableEarning.availableEarningInBNB : 0.00}
                displayType="text"
                suffix=' BNB'
                decimalScale={4}
                thousandSeparator={true}
              />
            </span>
            <span className="dragon-amount-dollar-value">
              (<NumberFormat
                value={userAvailableEarning ? userAvailableEarning.availableEarningInUSD : 0.00}
                displayType="text"
                prefix='$'
                decimalScale={2}
                thousandSeparator={true}
              />)
            </span>
          </div>
        </Col>
      </Row>
      <Row className='dragon-farm-statistic-container'>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className='stat-details-topic'>
            <AreaChartOutlined style={{ marginRight: '5px', marginTop: '4px' }} />Estimated daily yield
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className='stat-details-value'>
            <span className="dragon-amount-stat">
              <NumberFormat
                value={estimatedDailyYield ? estimatedDailyYield.estimatedDailyYieldInBNB : 0.00}
                displayType="text"
                suffix=' BNB'
                decimalScale={4}
                thousandSeparator={true}
              />
            </span><span className="dragon-amount-dollar-value">
              (<NumberFormat
                value={estimatedDailyYield ? estimatedDailyYield.estimatedDailyYieldInUSD : 0.00}
                displayType="text"
                prefix='$'
                decimalScale={2}
                thousandSeparator={true}
              />)
            </span>
          </div>
        </Col>
      </Row>
      <Row className='dragon-farm-statistic-container'>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className='stat-details-topic'>
            <StockOutlined style={{ marginRight: '5px', marginTop: '4px' }} />Breading count
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className='stat-details-value'>
            <span className="dragon-amount-stat">
              {userDragonDetails ? userDragonDetails.farmerCompoundCount : 0}
            </span><span className="dragon-amount-dollar-value">Time/s</span>
          </div>
        </Col>
      </Row>
      <Row className='dragon-farm-statistic-container'>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className='stat-details-topic'>
            <ClockCircleOutlined style={{ marginRight: '5px', marginTop: '4px' }} />Cart will be full in
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className='stat-details-value'>
            <span className="dragon-amount-stat">
              <CartFullCountDownTimer accountAddress={account} />
            </span>
          </div>
        </Col>
      </Row>
      <Row className='dragon-farm-statistic-container'>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className='stat-details-topic'>
            <HourglassOutlined style={{ marginRight: '5px', marginTop: '4px' }} />next hire bonus is activated
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className='stat-details-value'>
            <span className="dragon-amount-stat">
              <NextBonusTimeTimer accountAddress={account} />
            </span>
          </div>
        </Col>
      </Row>
      <div className='hiring-dragon-button-container mt-3'>
        <SellDragonsButton accountAddress={account} />
      </div>

      <div className='hiring-dragon-button-container'>
        <BreedMoreButton accountAddress={account} />
      </div>
    </div >
  )
}
